import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const CREATE_LEAD = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createLead',
    operationName: 'createLead',
    args: [
      { name: 'developer_project_id', type: 'String', required: true },
      { name: 'name', type: 'String', required: true },
      { name: 'preferred_name', type: 'String', required: true },
      { name: 'mobile_prefix', type: 'String', required: true },
      { name: 'mobile', type: 'String', required: true },
      { name: 'identity', type: 'String', required: true },
      { name: 'loan_amount', type: 'String', required: true },
      { name: 'opportunity_id', type: 'String' },
      { name: 'email', type: 'String' },
      { name: 'identity_type', type: 'String' },
    ],
    argsMap: [
      { name: 'developer_project_id', value: 'developer_project_id' },
      { name: 'name', value: 'name' },
      { name: 'preferred_name', value: 'preferred_name' },
      { name: 'mobile_prefix', value: 'mobile_prefix' },
      { name: 'mobile', value: 'mobile' },
      { name: 'identity', value: 'identity' },
      { name: 'loan_amount', value: 'loan_amount' },
      { name: 'opportunity_id', value: 'opportunity_id' },
      { name: 'email', value: 'email' },
      { name: 'identity_type', value: 'identity_type' },
    ],
    fields: '{...LeadResponseFields}',
    fragments: [Fragments.leadResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const CREATE_LEAD_ACTIVITY_LOG = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createLeadActivityLog',
    operationName: 'createLeadActivityLog',
    args: [
      { name: 'opportunity_id', type: 'String', required: true },
      { name: 'message', type: 'String', required: true },
      { name: 'type', type: 'String', required: true },
      { name: 'notify_bankers', type: 'Boolean' },
    ],
    argsMap: [
      { name: 'opportunity_id', value: 'opportunity_id' },
      { name: 'message', value: 'message' },
      { name: 'type', value: 'type' },
      { name: 'notify_bankers', value: 'notify_bankers' },
    ],
    fields: '{...LeadActivityResponseFields}',
    fragments: [Fragments.leadActivityResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const CREATE_BANK_CASES = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createBankCases',
    operationName: 'createBankCases',
    args: [
      { name: 'opportunity_id', type: 'String', required: true },
      { name: 'bank_cases', type: '[CreateLeadBankCaseInput!]', required: true },
    ],
    argsMap: [
      { name: 'opportunity_id', value: 'opportunity_id' },
      { name: 'bank_cases', value: 'bank_cases' },
    ],
    fields: '{...LeadResponseFields}',
    fragments: [Fragments.leadResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
